import type { MailboxInfo } from 'owa-client-types';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { SearchScopeKind, type SearchScope } from 'owa-search-service/lib/data/schema/SearchScope';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';

// Determines if the "Include Deleted" toggle can be shown for the given search scope and mailbox.
// The toggle can only be shown for primary, archive, shared, or PST mailbox scopes that are at the root folder level.
export default function canToggleSearchIncludeDeleted(
    scope: SearchScope | undefined,
    mailboxInfo: MailboxInfo | undefined
): boolean {
    if (
        !isGlobalFeatureEnabled('sea-toggleIncludeDeleted') ||
        !mailboxInfo ||
        !scope ||
        (scope.kind !== SearchScopeKind.PrimaryMailbox &&
            scope.kind !== SearchScopeKind.ArchiveMailbox &&
            scope.kind !== SearchScopeKind.SharedFolders &&
            scope.kind !== SearchScopeKind.PstFile) ||
        ('isCurrentFolderScope' in scope && scope.isCurrentFolderScope) ||
        ('isSubfolderScope' in scope && scope.isSubfolderScope)
    ) {
        return false;
    }

    const folderName = folderIdToName(scope.folderId, true);
    if (folderName !== 'msgfolderroot' && folderName !== 'archivemsgfolderroot') {
        return false;
    }

    return !!folderNameToId(
        folderName === 'archivemsgfolderroot' ? 'archivedeleteditems' : 'deleteditems',
        mailboxInfo,
        true /* shouldSearchShared */
    );
}
